import { FUtil } from '@freelog/tools-lib';
import { fetchEventSource } from '@microsoft/fetch-event-source';

export class CoverGenerator {
  public static generateCover(
    sha1s: string[],
    onMessage: (data: { sha1: string; url: string }) => void,
    onEnd: () => void,
  ): () => void {
    const ctrl = new AbortController();
    fetchEventSource(
      // `${FUtil.Format.completeUrlByDomain('api')}/v2/storages/files/imageHandleSSE`,
      `${FUtil.Format.completeUrlByDomain('api')}/v2/storages/files/generateCoverImageSSE`,
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          // Authorization: 'Bearer YOUR_TOKEN',
        },
        body: JSON.stringify({ sha1Array: sha1s }),
        signal: ctrl.signal,
        onopen(response) {
          console.groupCollapsed('%c生成封面 连接打开', 'color: red; font-size: 16px;');
          console.info('响应', response);
          return Promise.resolve();
        },
        onmessage(event) {
          console.info('生成封面 实时数据: ', event.data);
          const data: { sha1: string; url: string } = JSON.parse(event.data);
          onMessage(data);
        },
        onerror(err) {
          console.error('SSE 错误:', err);
          ctrl.abort();
          onEnd();
        },
        onclose() {
          console.info('生成封面 连接关闭');
          console.groupEnd();
          onEnd();
        },
      },
    );
    return ctrl.abort;
  }

  public static generateCoverPromise(sha1s: string[]): Promise<string[]> {
    return new Promise((resolve) => {
      const result: string[] = [];
      this.generateCover(
        sha1s,
        (data) => {
          result.push(data.url);
        },
        () => {
          resolve(result);
        },
      );
    });
  }
}
